/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal Pre-Auth
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ResumeCheckResult } from '../model';
// @ts-ignore
import { ResumeCredentials } from '../model';
// @ts-ignore
import { ResumeHandleRequest } from '../model';
// @ts-ignore
import { ResumeRedeemRequest } from '../model';
// @ts-ignore
import { ResumeStatus } from '../model';
/**
 * ResumeApi - axios parameter creator
 * @export
 */
export const ResumeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary What the logged-in session means for a tab\'s saved place.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResume: async (resumeHandleRequest: ResumeHandleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeHandleRequest' is not null or undefined
            assertParamExists('checkResume', 'resumeHandleRequest', resumeHandleRequest)
            const localVarPath = `/resume/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeHandleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The admin chose not to resume the impersonation saved under this handle.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineResumeImpersonation: async (resumeHandleRequest: ResumeHandleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeHandleRequest' is not null or undefined
            assertParamExists('declineResumeImpersonation', 'resumeHandleRequest', resumeHandleRequest)
            const localVarPath = `/resume/impersonation/decline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeHandleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Call only after user activity, never on a timer: the request extends the session. Hold the response in memory only. 
         * @summary Create or refresh this session\'s resume credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumeCredentials: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/resume/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called while logged out. Not found when the record is gone or the org has no logo; fall back to the existing logged-out logo. Rate-limited. 
         * @summary The logo of the org a handle\'s record belongs to.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumeLogo: async (resumeHandleRequest: ResumeHandleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeHandleRequest' is not null or undefined
            assertParamExists('getResumeLogo', 'resumeHandleRequest', resumeHandleRequest)
            const localVarPath = `/resume/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeHandleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called while logged out. A malformed or unknown handle is gone. Rate-limited.
         * @summary Whether a handle\'s record still exists, and its language.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumeStatus: async (resumeHandleRequest: ResumeHandleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeHandleRequest' is not null or undefined
            assertParamExists('getResumeStatus', 'resumeHandleRequest', resumeHandleRequest)
            const localVarPath = `/resume/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeHandleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary As check, and returns the tab\'s page address when the result is restore.
         * @param {ResumeRedeemRequest} resumeRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemResume: async (resumeRedeemRequest: ResumeRedeemRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeRedeemRequest' is not null or undefined
            assertParamExists('redeemResume', 'resumeRedeemRequest', resumeRedeemRequest)
            const localVarPath = `/resume/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeRedeemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResumeApi - functional programming interface
 * @export
 */
export const ResumeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResumeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary What the logged-in session means for a tab\'s saved place.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkResume(resumeHandleRequest: ResumeHandleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeCheckResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkResume(resumeHandleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The admin chose not to resume the impersonation saved under this handle.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineResumeImpersonation(resumeHandleRequest: ResumeHandleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineResumeImpersonation(resumeHandleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Call only after user activity, never on a timer: the request extends the session. Hold the response in memory only. 
         * @summary Create or refresh this session\'s resume credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResumeCredentials(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeCredentials>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResumeCredentials(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called while logged out. Not found when the record is gone or the org has no logo; fall back to the existing logged-out logo. Rate-limited. 
         * @summary The logo of the org a handle\'s record belongs to.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResumeLogo(resumeHandleRequest: ResumeHandleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResumeLogo(resumeHandleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called while logged out. A malformed or unknown handle is gone. Rate-limited.
         * @summary Whether a handle\'s record still exists, and its language.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResumeStatus(resumeHandleRequest: ResumeHandleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResumeStatus(resumeHandleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary As check, and returns the tab\'s page address when the result is restore.
         * @param {ResumeRedeemRequest} resumeRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemResume(resumeRedeemRequest: ResumeRedeemRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeCheckResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemResume(resumeRedeemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResumeApi - factory interface
 * @export
 */
export const ResumeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResumeApiFp(configuration)
    return {
        /**
         * 
         * @summary What the logged-in session means for a tab\'s saved place.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkResume(resumeHandleRequest: ResumeHandleRequest, options?: any): AxiosPromise<ResumeCheckResult> {
            return localVarFp.checkResume(resumeHandleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The admin chose not to resume the impersonation saved under this handle.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineResumeImpersonation(resumeHandleRequest: ResumeHandleRequest, options?: any): AxiosPromise<void> {
            return localVarFp.declineResumeImpersonation(resumeHandleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Call only after user activity, never on a timer: the request extends the session. Hold the response in memory only. 
         * @summary Create or refresh this session\'s resume credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumeCredentials(options?: any): AxiosPromise<ResumeCredentials> {
            return localVarFp.getResumeCredentials(options).then((request) => request(axios, basePath));
        },
        /**
         * Called while logged out. Not found when the record is gone or the org has no logo; fall back to the existing logged-out logo. Rate-limited. 
         * @summary The logo of the org a handle\'s record belongs to.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumeLogo(resumeHandleRequest: ResumeHandleRequest, options?: any): AxiosPromise<any> {
            return localVarFp.getResumeLogo(resumeHandleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Called while logged out. A malformed or unknown handle is gone. Rate-limited.
         * @summary Whether a handle\'s record still exists, and its language.
         * @param {ResumeHandleRequest} resumeHandleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumeStatus(resumeHandleRequest: ResumeHandleRequest, options?: any): AxiosPromise<ResumeStatus> {
            return localVarFp.getResumeStatus(resumeHandleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary As check, and returns the tab\'s page address when the result is restore.
         * @param {ResumeRedeemRequest} resumeRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemResume(resumeRedeemRequest: ResumeRedeemRequest, options?: any): AxiosPromise<ResumeCheckResult> {
            return localVarFp.redeemResume(resumeRedeemRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResumeApi - object-oriented interface
 * @export
 * @class ResumeApi
 * @extends {BaseAPI}
 */
export class ResumeApi extends BaseAPI {
    /**
     * 
     * @summary What the logged-in session means for a tab\'s saved place.
     * @param {ResumeHandleRequest} resumeHandleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public checkResume(resumeHandleRequest: ResumeHandleRequest, options?: any) {
        return ResumeApiFp(this.configuration).checkResume(resumeHandleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The admin chose not to resume the impersonation saved under this handle.
     * @param {ResumeHandleRequest} resumeHandleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public declineResumeImpersonation(resumeHandleRequest: ResumeHandleRequest, options?: any) {
        return ResumeApiFp(this.configuration).declineResumeImpersonation(resumeHandleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Call only after user activity, never on a timer: the request extends the session. Hold the response in memory only. 
     * @summary Create or refresh this session\'s resume credentials.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public getResumeCredentials(options?: any) {
        return ResumeApiFp(this.configuration).getResumeCredentials(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called while logged out. Not found when the record is gone or the org has no logo; fall back to the existing logged-out logo. Rate-limited. 
     * @summary The logo of the org a handle\'s record belongs to.
     * @param {ResumeHandleRequest} resumeHandleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public getResumeLogo(resumeHandleRequest: ResumeHandleRequest, options?: any) {
        return ResumeApiFp(this.configuration).getResumeLogo(resumeHandleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called while logged out. A malformed or unknown handle is gone. Rate-limited.
     * @summary Whether a handle\'s record still exists, and its language.
     * @param {ResumeHandleRequest} resumeHandleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public getResumeStatus(resumeHandleRequest: ResumeHandleRequest, options?: any) {
        return ResumeApiFp(this.configuration).getResumeStatus(resumeHandleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary As check, and returns the tab\'s page address when the result is restore.
     * @param {ResumeRedeemRequest} resumeRedeemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public redeemResume(resumeRedeemRequest: ResumeRedeemRequest, options?: any) {
        return ResumeApiFp(this.configuration).redeemResume(resumeRedeemRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
